/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Possible appointment status
 * @export
 */
export const AppointmentStatusEnum = {
    Pending: 'PENDING',
    Completed: 'COMPLETED',
    Confirmed: 'CONFIRMED',
    Cancelled: 'CANCELLED'
} as const;
export type AppointmentStatusEnum = typeof AppointmentStatusEnum[keyof typeof AppointmentStatusEnum];


export function instanceOfAppointmentStatusEnum(value: any): boolean {
    for (const key in AppointmentStatusEnum) {
        if (Object.prototype.hasOwnProperty.call(AppointmentStatusEnum, key)) {
            if (AppointmentStatusEnum[key as keyof typeof AppointmentStatusEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AppointmentStatusEnumFromJSON(json: any): AppointmentStatusEnum {
    return AppointmentStatusEnumFromJSONTyped(json, false);
}

export function AppointmentStatusEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppointmentStatusEnum {
    return json as AppointmentStatusEnum;
}

export function AppointmentStatusEnumToJSON(value?: AppointmentStatusEnum | null): any {
    return value as any;
}

export function AppointmentStatusEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): AppointmentStatusEnum {
    return value as AppointmentStatusEnum;
}

